/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Link, Outlet} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Author} from "../../components/common/author/Author";

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])
  return (
      <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
        <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-1 order-lg-1'>
          <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
            <div className='w-lg-500px p-10'>
              <Outlet/>
            </div>
          </div>

          <div className='d-flex flex-center flex-wrap px-5'>
            <div className='d-flex fw-semibold text-primary fs-base'>
              <Author/>
            </div>
          </div>
        </div>

        <div
            className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover m-5 rounded-4 bgi-position-center order-2 order-lg-2'
            style={{backgroundImage: `url(${toAbsoluteUrl('/media/misc/auth-bg.png')})`}}
        >
          <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
            <Link to='/' className='mb-12'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/custom-3.svg')} className='h-75px'/>
            </Link>

            <img
                className='mx-auto w-75 w-md-50 w-xl-75 mb-10 mb-lg-20'
                src={toAbsoluteUrl('/media/misc/auth-screens.png')}
                alt=''
            />

            <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>
              Bola himoyasi
            </h1>

            <div className='text-white text-center'>
              <p className={"fs-base w-75 mx-auto"}>
                Sizning xavfsizligingiz ta'minoti bizning muhim vazifamizdir. Bizning platformamizga kirish uchun
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab amet, architecto quod sint sunt unde!
              </p>
            </div>
          </div>
        </div>
      </div>
  )
}

export {AuthLayout}
